import React from "react";
import { useAppSelector, useAppDispatch } from "../../../../app/hooks";
import {
  deleteDVIRReport,
  resetShowDeleteReportConfirmationModal,
} from "../../dvirSlice";
import "./DeleteReportModal.scss";

const formatDate = (dateString: string): string => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export function DeleteReportModal() {
  const dispatch = useAppDispatch();
  const reportToDelete = useAppSelector(
    (state) => state.dvir.showDeleteReportConfirmationModal
  );
  const deleteAPI = useAppSelector((state) => state.dvir.deleteDVIRReport);

  const handleConfirmDelete = () => {
    if (reportToDelete) {
      dispatch(deleteDVIRReport(reportToDelete.id));
    }
  };

  const handleClose = () => {
    dispatch(resetShowDeleteReportConfirmationModal());
  };

  if (!reportToDelete) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div
        className="delete-report-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>Delete DVIR Report</h3>
          <button className="close-button" onClick={handleClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          <div className="delete-confirmation">
            <div className="danger-icon">🗑️</div>
            <div className="confirmation-content">
              <p className="confirmation-title">
                Are you sure you want to delete this DVIR report?
              </p>
              <div className="report-preview">
                <div className="report-info">
                  <span className="label">Date:</span>
                  <span className="value">{formatDate(reportToDelete.date)}</span>
                </div>
                <div className="report-info">
                  <span className="label">Driver:</span>
                  <span className="value">{reportToDelete.driverName}</span>
                </div>
                <div className="report-info">
                  <span className="label">Vehicle:</span>
                  <span className="value">{reportToDelete.vehicleLabel}</span>
                </div>
                <div className="report-info">
                  <span className="label">Template:</span>
                  <span className="value">{reportToDelete.templateName}</span>
                </div>
              </div>
              <p className="confirmation-warning">
                This action cannot be undone. The report will be permanently
                removed from the system.
              </p>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
            disabled={deleteAPI.loading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleConfirmDelete}
            disabled={deleteAPI.loading}
          >
            {deleteAPI.loading ? "Deleting..." : "Delete Report"}
          </button>
        </div>
      </div>
    </div>
  );
}
